/**
 * @name BulkOrderPLP_DynamicTables.Entry.js
 *
 * @author Anchor Group : Anthony Dittus <adttus@anchorgroup.tech>
 * @since 2024-02-29
 * 
 * @file Builds out a Bulk Order Page replacing the PLP List view with configurable Dynamic Header Sorting
 * 
 */

define(
	'BulkOrderPLP_DynamicTables.Entry',
	[
		'Facets.Browse.View',
		'underscore',
		'Backbone.CollectionView',
		'BulkOrderPLP_DynamicTables.CategoryCollection.View',
		'Profile.Model'
	],
	function (
		FacetsBrowseView,
		_,
		BackboneCollectionView,
		BulkOrderPLP_DynamicTablesCategoryCollectionView,
		ProfileModel
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				const LayoutComponent = container.getComponent('Layout');
				const CartComponent = container.getComponent('Cart');
				const PLPComponent = container.getComponent('PLP');
				const EnvironmentComponent = container.getComponent('Environment');

				const BulkOrderPLPDynamicTablesConfig = EnvironmentComponent.getConfig('BulkOrderPLPDynamicTables.productPageFields') || [];


				//* Process the list view items to be sorted into categories with their respective headers and configured column field ids
				_.extend(FacetsBrowseView.prototype, {
					getContext: _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {
						let context = fn.apply(this, _.toArray(arguments).slice(1));
						let isListView = PLPComponent.getDisplay().id == "list";
						if (isListView) {
							let itemModels = this.model.get('items').models;
							let bulkOrderItemCategoryObject = new Object;
							if (itemModels.length > 0) {
								itemModels.forEach(function (itemModel) {
									//* If item matches
									//*		first result: push header and then result
									//* 	second onward: find index value and push to that array
									let pushedIntoAnArray;
									for (let configIndex = 0; configIndex < BulkOrderPLPDynamicTablesConfig.length; configIndex++) {
										if (BulkOrderPLPDynamicTablesConfig[configIndex].itemCategoryFieldValue == itemModel.get(BulkOrderPLPDynamicTablesConfig[configIndex].itemCategoryField)) {
											itemModel.set('configObj', BulkOrderPLPDynamicTablesConfig[configIndex]);
											itemModel.set('categorySectionIndex', configIndex);

											if (!bulkOrderItemCategoryObject[configIndex]) { //* initialize if no value yet
												let initializedArrayWithHeader = [{
													isHeader: true,
													configObj: BulkOrderPLPDynamicTablesConfig[configIndex],
													categoryItemIDs: [itemModel.id],
													categorySectionIndex: configIndex
												}];

												initializedArrayWithHeader.push(itemModel);
												bulkOrderItemCategoryObject[configIndex] = initializedArrayWithHeader;
											} else {
												let categorySection = bulkOrderItemCategoryObject[configIndex];
												bulkOrderItemCategoryObject[configIndex][0].categoryItemIDs.push(itemModel.id);
												categorySection.push(itemModel);
											}
											pushedIntoAnArray = true;
											break;
										}
									}

									//* Handling for if not pushed to put into a default array of items to display at the bottom below all potential sections
									if (!pushedIntoAnArray) {
										itemModel.set('categorySectionIndex', 101);
										if (!bulkOrderItemCategoryObject[101]) { //* initialize default section if nothing in it yet 
											bulkOrderItemCategoryObject[101] = [{
													isHeader: true,
													configObj: [], //* No config for default
													categoryItemIDs: [itemModel.id],
													categorySectionIndex: 101
												},
												itemModel
											];
										} else {
											bulkOrderItemCategoryObject[101][0].categoryItemIDs.push(itemModel.id);
											bulkOrderItemCategoryObject[101].push(itemModel);
										}
									}
								});

								//* Sort and compile the column sets
								let sortedKeys = Object.keys(bulkOrderItemCategoryObject).sort();
								let bulkOrderCategoryArray = new Array;
								for (let i = 0; i < sortedKeys.length; i++) {
									let sortedKey = sortedKeys[i];
									bulkOrderCategoryArray.push(bulkOrderItemCategoryObject[sortedKey]);
								}
								bulkOrderCategoryArray[0][0].isFirstHeader = true;
								this.bulkOrderCategoryArray = bulkOrderCategoryArray;
							}
						}

						return context;
					}),

					//* Replace the list view to allow for container views, sticky banners, etc
					childViews: _.extend(FacetsBrowseView.prototype.childViews, {
						'Facets.Items': _.wrap(FacetsBrowseView.prototype.childViews['Facets.Items'], function (fn) {

							if (this.translator.options.display != 'list') {
								return fn.apply(this, _.toArray(arguments).splice(1));
							} else {
								return new BackboneCollectionView({
									collection: this.bulkOrderCategoryArray,
									childView: BulkOrderPLP_DynamicTablesCategoryCollectionView,
									childViewOptions: {
										application: this.application,
										CartComponent: CartComponent,
										LayoutComponent: LayoutComponent,
										hidePricing: ProfileModel.getInstance().hidePrices()
									}
								});
							}
						})
					})
				});
			}
		};
	});
